import { FlushCacheForm } from "@components/flush_cache_form/flush_cache_form";
import { RefreshArtistForm } from "@components/refresh_artist_form/refresh_artist_form";
import React, { type FC } from "react";

const ManagementPage: FC = () => {
  return (
    <div className="content">
      <header>
        <h1>Management</h1>
      </header>
      <section className="admin-cache">
        <article className="admin-cache--refresh-artist">
          <h2>Artist Refresh</h2>
          <p>
            This control allows you to freshen up data for a particular artist.
            Typically Mission Artists and 1890 Bryant websites talk to each
            other and try to keep things up to date but if there is a miss, this
            should force the site to requery data from Mission Artists and make
            everything better.
          </p>
          <RefreshArtistForm />
        </article>
        <article className="admin-cache--refresh-artist">
          <h2>System data cache</h2>
          <p>
            This button will clear the application cache which includes data
            from Mission Artists. If you believe the Mission Artists' data is
            out of sync and you can't update an individual Artist, this might be
            appropriate. It will cause some performance issues right after it's
            pressed as the system will need to repopulate the cache.
          </p>
          <p>Use with caution.</p>
          <FlushCacheForm />
        </article>
      </section>
    </div>
  );
};

export { ManagementPage };
